import { render, staticRenderFns } from "./TPanel.vue?vue&type=template&id=0b88fa7c&"
import script from "./TPanel.vue?vue&type=script&lang=ts&"
export * from "./TPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports